import React, { Component } from 'react';
import { Button, Tabs, Row,Badge, Col, Modal, Icon, Input, message, Form,Alert,Drawer,Card, Table, LocaleProvider,InputNumber, Select, DatePicker, Radio, Upload,Descriptions } from 'antd';
import Crumbs from './../../../Crumbs/Crumbs';//面包屑
import evn from "./../../../../../actions/index";//action的所有事件
import { connect } from "react-redux";//联系store的组件
import CaseDetailsInfoModal from "./../../../Common/CaseDetailsInfoModal";//登记单详情
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import { Hcurl, UpLoadedFilesUrl, uploadAction } from "./../../../../../constants/index";//获取公共路径
import Event from "./../../../../../assets/PubJs/hcPub";//所有事件
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import $ from "jquery";

import createHistory from 'history/createHashHistory';//路由切换地址
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./../style.css"
import moment from 'moment';
const { MonthPicker, RangePicker } = DatePicker;
const Option = Select.Option;
const history = createHistory();//定义history路由
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { TextArea } = Input;
const { Search } = Input;
const { confirm } = Modal;

var _SendVoucher = null
class SendVoucher extends Component{
    state={
        visible:false,
        fileList:[],
        accountInfo:[],
        states:'新增',
        loading:false,
    }
    componentDidMount(){
        _SendVoucher =  this
    }
    onClose=()=>{
        this.setState({
            visible:false
        })
    }
    handleChange = (info) => {  //文件上传方法
        console.log(info)
        
        if(info.fileList.length==0){
            setTimeout(() => {
                _SendVoucher.props.form.setFieldsValue({
                    CP_Attach:undefined
                })
            }, 100);
            
        }
        let fileList = info.fileList;
        if (info.file.status != "error") {
            if (info.file.status == "done") {
                message.success(`${info.file.name} 文件上传成功`);
                _SendVoucher.setState({
                    loading:false
                })
            } else {
                if (info.file.status == "removed") {
                    message.success(`${info.file.name} 文件移除成功`);
                    _SendVoucher.setState({
                        loading:false
                    })
                }
            }
            fileList = fileList.map((file) => {
                console.log('70',file)
                if (file.response) {
                    file.url = file.response;
                }
                return file;
            });
            var filePath = ''
            if (info.file.size < 20971520 || info.file.size == null) {
                filePath = fileList;
                _SendVoucher.setState({ fileList: filePath });
            } else {
                filePath = _SendVoucher.state.fileList
                _SendVoucher.setState({ fileList: filePath });
            }
           
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 文件上传失败`);
            _SendVoucher.setState({
                loading:false
            })
        }

    }
    //上传前置事件
    beforeUpload = (file) => {
        this.setState({
            loading:true
        })
        let arr = (file.type.indexOf('image')>-1)
        return new Promise((resolve, reject) => {
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (!isLt2M) {
                message.error('仅支持图片类型附件上传，最多6个，每个最大20M');
                return reject(false)
            }
            else {
                this.setState({ dataName: file.name })
            }
            if (!arr) {
                message.error('仅支持图片类型附件上传，最多6个，每个最大20M');
                return reject(false)
            }
            return resolve(true);
        })
    }
    GetDate(now, itype) {
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var date = now.getDate();
        var hour = now.getHours();
        var minute = now.getMinutes();
        var second = now.getSeconds();
        var sssecond = now.getMilliseconds()
        if (itype == "yyyy-MM-dd hh:mm:ss")
            return year + "-" + (month < 10 ? "0" + month : month) + "-" + (date < 10 ? "0" + date : date) + " " + (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute) + ":" +(second < 10 ? "0" + second : second);
        else if (itype == "yyyy-MM-dd hh:mm")
            return year + "-" + (month < 10 ? "0" + month : month) + "-" + (date < 10 ? "0" + date : date) + " " + (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute);
        else if (itype == "yyyy-MM-dd")
            return year + "-" + month + "-" + date;
        else if (itype == "yyyy-MM")
            return year + "-" + month;
        else if (itype == "MM-dd")
            return month + "-" + date;
        else if (itype == 'ssss')
            return year + "" + month + "" + date + "" + hour + "" + minute + "" + second + "" + sssecond
    
    }
    feedBack=()=>{
        this.setState({
            loading:true
        })
      
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let imageUrl = '';
                $.each(this.state.fileList, function (ids, txt) {
                    if (txt.url !== '')
                        imageUrl += txt.url + ';';
                })
                imageUrl = imageUrl.substring(0, imageUrl.length - 1);
                $.ajax({
                    url: Hcurl + "/Business/OperateCompanyCollectApply",
                    type: "post",
                    data: {
                        id:0,
                        UserCode: EventSet.getUserInfo()['CU_Code'],//当前操作人
                        UsertTimeCode:EventSet.getUserInfo()['CU_Code']+''+_SendVoucher.GetDate(new Date(), 'ssss'),// 当前操作人+ 时间戳
                        ComCode: EventSet.getUserInfo()['xxhjcompanycode'],//当前选择企业code
                        ComName: EventSet.getUserInfo()['XXHJCom_Name'],//当前选择企业名称
                        AccountCode:_SendVoucher.state.accountInfo[0].AccountCode,// 当前选择资金账户code
                        OperateType: '1',// 1 新增 2 删除 3 撤回
                        CaAmount:values.repaymentMoney!=undefined?values.repaymentMoney.toFixed(2):'',// 金额
                        Attachs:imageUrl,// 附件
                        Commet:values.remark,// 备注 
                        JoinMan:EventSet.getUserInfo()['userName'],// 当前操作人姓名
                    },
                    async: false,
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (res) {
                        console.log(res, 'res');
                        if(res.indexOf('true')>-1){
                            message.success(res.split('|')[1])
                        }else{
                            message.error(res.split('|')[1])
                        }
                        _SendVoucher.setState({
                            visible:false,
                          
                        })
                        setTimeout(() => {
                            _SendVoucher.setState({
                                loading:false,
                              
                            })
                        }, 100);
                        _App.fench()
                       
                    },
                    error: function (data, err) {
                        if (!JSON.parse(data.responseText).success && data.status === 403) {
                            history.push({ "pathname": "/err" })
                        } else {
                            message.error(err)
                        }
                    }
                })
            } else {
                message.warn('请检查后重新尝试');
                _SendVoucher.setState({
                    loading:false
                })
                return
            }
        });
    }
    render(){
        const { getFieldDecorator } = this.props.form;
        const head = { 'X-Requested-With': null }
        const cusSymbol = '￥'
        const reg = new RegExp(`${cusSymbol}\\s?|(,*)`,'g')
        return (
            <div>
               <Drawer
                    title="提交还款凭证"
                    placement="right"
                    onClose={this.onClose}
                    visible={this.state.visible}
                    width={720}
                    >
                    <Alert style={{marginBottom:'24px'}} message="还款至如下资金账户后，在此处提交还款凭证，经由监管部门审核后完成还款。" type="info" showIcon />
                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold'}}>资金账户信息</p>
                    <Descriptions size="middle" bordered>
                        <Descriptions.Item label="资金账户" span={3}>{this.state.accountInfo.length>0?this.state.accountInfo[0].AccountName:''}</Descriptions.Item>
                        <Descriptions.Item label="我的余额（元）" ><div style={{width:'120px'}}>{this.state.accountInfo.length>0?EventSet.numberFormat(this.state.accountInfo[0].BillAmount,2):''}</div></Descriptions.Item>
                        <Descriptions.Item label="更新时间" span={2} ><div style={{width:'130px'}}>{this.state.accountInfo.length>0?this.state.accountInfo[0].LastUpdatetime.substring(0,16):''}</div></Descriptions.Item>
                        <Descriptions.Item label="还款说明" span={3}>{this.state.accountInfo.length>0?this.state.accountInfo[0].Comment:''}</Descriptions.Item>
                    </Descriptions>

                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>还款凭证信息</p>
                    <Form  className='formSearch' style={{ marginLeft: 10,paddingBottom:'80px' }}>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem
                                    label="还款金额（元）"
                                >
                                    {getFieldDecorator('repaymentMoney' ,{
                                    rules: [
                                        { required: true, message: '请输入还款金额' },
                                    ],
                                })(
                                    <InputNumber style={{width:'100%'}}
                                    formatter={value => `${cusSymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(reg, '')}
                                    precision={2}
                                    max={ 999999999999.00}
                                    min={ -999999999999.00}
                                  />
                                    )}
                                </FormItem>
                            </Col>
                           

                        </Row>
                        <Row gutter={24}>
                        <Col span={24}>
                                    <FormItem
                                        label="还款凭证"
                                    >
                                        {getFieldDecorator('CP_Attach', {
                                            rules: [{ required: true, message: '请上传还款凭证' }],
                                        }
                                        )(
                                         <Upload
                                                name="file"
                                                // action="https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"
                                                action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                                                onChange={this.handleChange}
                                                beforeUpload={this.beforeUpload}
                                                fileList={this.state.fileList}
                                                headers={head}
                                              
                                            ><Button disabled={ this.state.fileList.length >= 6?true:false}>
                                                    <Icon type="upload" /> 附件上传
                                            </Button><span style={{fontSize:'12px',marginLeft:'10px'}}>转账截图等还款凭证（保证内容清晰可见），最多上传6个附件，每个20M以内</span> 
                                </Upload> )}
                                    </FormItem>
                                </Col>
                        </Row>

                        <Row gutter={24} >
                            <Col span={24}>
                                <FormItem
                                    label="备注"
                                >
                                     {getFieldDecorator('remark',{
                                    rules: [
                                        { required: false, message: '请输入备注' },
                                    ],
                                })(
                                    <TextArea rows={4} maxLength={400} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        


            </Form>

          <div style={{position:"absolute",right:'0',bottom:'0',height:'50px',width:'100%',padding:'0 24px',lineHeight:'50px',borderTop:'1px solid #f2f2f2',background:"#fff"}}>
              <Button loading={this.state.loading} onClick={this.feedBack} style={{float:'right',marginTop:'10px'}} type="primary">提交</Button>
              <Button onClick={this.onClose} style={{float:'right',marginRight:'8px',marginTop:'10px'}}>取消</Button>
              
          </div>
                </Drawer>
            </div>
        )
    }

}
const SendVoucherWrapper = Form.create()(SendVoucher);


//切换账户抽屉
var _mainDawer = null
class MainDawer extends Component{
    state={
        visible:false,
        listData:[],
        AccountInfo:[],
    }
    componentDidMount(){
        _mainDawer =this
        this.getAccount()
    }
    getAccount(){
        $.ajax({
            url: Hcurl + "/Business/GetBillAccountList",
            type: "post",
            data: {
                UserCode: Event.getUserInfo().CU_Code,
                ComCode:Event.getUserInfo().xxhjcompanycode,
            },
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                console.log('215',res)
           
                    // if( localStorage.getItem('allount')==undefined||localStorage.getItem('allount')==null){
                        localStorage.setItem('allount',res[0].AccountName)
                        localStorage.setItem('allountMoney',res[0].BillAmount)
                    // }
                    
                
              
                res.map((item) => {
                    if (item.AccountName == localStorage.getItem("allount")) {
                      item.isSelected = true;
                    }
                  });
                  _mainDawer.setState({
                    listData:res
                })
                _mainDawer.getAccountInfo(res[0].AccountCode)
               
            },
            error: function (data, err) {
                // if (!JSON.parse(data.responseText).success && data.status === 403) {
                //     history.push({ "pathname": "/err" })
                // } else {
                //     message.error(err)
                // }
            }
        })
    }
    getAccountInfo(code){
        $.ajax({
            url: Hcurl + "/Business/GetAccountInfo",
            type: "post",
            data: {
                UserCode: Event.getUserInfo().CU_Code,
                ComCode:Event.getUserInfo().xxhjcompanycode,
                AccountCode:code,
            },
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
               
               console.log('256',res)
               _App.setState({
                accountData:res
               })

               setTimeout(() => {
                   _App.fench()
               }, 100);
              
            },
            error: function (data, err) {
                // if (!JSON.parse(data.responseText).success && data.status === 403) {
                //     history.push({ "pathname": "/err" })
                // } else {
                //     message.error(err)
                // }
            }
        })
    }

    onClose = ()=>{
        this.setState({
            visible:false
        })
    }
    //切换选择
    changeSelect=(item,index)=> {

         var newdata = this.state.listData
         newdata.forEach((si,ind) => {
          si.isSelected = ind === index;
        });
 
        this.setState({
            listData:newdata
        })

      }
      addCompany = () => {
          var newArr  = this.state.listData.filter((item)=>{
              return item.isSelected
          })
          console.log('43',newArr)
  
        //   return false
          localStorage.setItem('allount',newArr[0].AccountName)
          localStorage.setItem('allountMoney',newArr[0].BillAmount)
          message.success('提交成功',0.5);
          _mainDawer.setState({
              visible:false
          })
          setTimeout(() => {
            window.location.reload()
        }, 500);
        
    }
    render(){
        return (
            <div>
                <Drawer
          title="切换账户"
          placement="right"
          onClose={this.onClose}
          visible={this.state.visible}
          width={540}
        >
            <div style={{paddingBottom:'50px'}}>
        {this.state.listData.map((item,index)=>{
            return (<div className="companyBox" style={{position:'relative',height:'40px'}} key={index} onClick={()=>this.changeSelect(item,index)} >
                    <div className="leftRadio" style={{marginTop:'8px'}}>
                        <Radio key={item.AccountCode} name={'aa'} checked={item.isSelected}></Radio>
                    </div>
                    <div className="rightName" >
                        <div className="companyName" title={item.AccountName}>{item.AccountName}</div>
                    </div>
            </div>) 
        })}
          </div>
          <div style={{position:"absolute",right:'0',bottom:'0',height:'50px',width:'100%',padding:'0 24px',lineHeight:'50px',borderTop:'1px solid #f2f2f2',background:'#fff'}}>
              <span>请选择需要切换的账户</span>
              <Button onClick={this.addCompany} style={{float:'right',marginTop:'10px'}} type="primary">提交</Button>
              <Button onClick={this.onClose} style={{float:'right',marginRight:'8px',marginTop:'10px'}}>取消</Button>
              
          </div>
        </Drawer>
        </div>
        )
    }
    
}

var _Bill = null 
class Bill extends React.Component{
    state={
        visible:false,
        data:[],
    }
    componentDidMount(){
        _Bill =  this
    }
    onClose=()=>{
        this.setState({
            visible:false
        })
    }
    fileName(url, array) {
        url = url || "";
        let fileName = "";
        if (url) {
            array.forEach(keys => {
                if (url.indexOf(keys) > -1) {
                    fileName = url.substring(url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } })[url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } }).length - 1] + 1, url.indexOf(keys) - 1) + '.' + keys
                }
            })
        }
        return fileName;
    }
    render(){
        return (
            <div>
               <Drawer
                    title="单据详情"
                    placement="right"
                    onClose={this.onClose}
                    visible={this.state.visible}
                    width={840}
                    >
                        {this.state.data.length>0? <div>
                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold'}}>基本信息</p>
                   <Descriptions size="middle" bordered>
                        <Descriptions.Item label={<div style={{width:'120px'}}>单据编号</div>}>{this.state.data[0].BillCode}</Descriptions.Item>
                        <Descriptions.Item label="添加时间" span={2} >{this.state.data[0].BillCreateTime}</Descriptions.Item>
                        <Descriptions.Item label="添加方式">{this.state.data[0].BillAddMethod}</Descriptions.Item>
                        <Descriptions.Item label="单据类型" span={2}>{this.state.data[0].BillType}</Descriptions.Item>
                        <Descriptions.Item label="所属资金账户" span={3}>
                        {this.state.data[0].AccountName}
                        </Descriptions.Item>
                        <Descriptions.Item label="具体金额（元）" span={3}>
                        {EventSet.numberFormat(this.state.data[0].BillAmount,2)}
                        </Descriptions.Item>
                        <Descriptions.Item label="附件" span={3}>{(this.state.data[0].BillAttachs!=''&&this.state.data[0].BillAttachs!=null)?this.state.data[0].BillAttachs.split(';').map((item)=>{
                            return <a href={item} target="_blank"> {this.fileName(item, ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp'])} </a>
                        })
                        
                        :'-'}</Descriptions.Item>
                        <Descriptions.Item label="备注" span={3}>
                        {this.state.data[0].BillComment}
                        </Descriptions.Item>
                    </Descriptions>
                    
                    {this.state.data[0].BillAddMethod=='自动录入'? <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>关联信息</p>:''}
                   
                    {(this.state.data[0].BillAddMethod=='自动录入'&&this.state.data[0].BillType=='商家回款' )?<Card style={{marginTop:'20px'}} size="small" title="还款凭证"  >
                        <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>还款信息</p>
                        <Descriptions size="middle" bordered>
                            <Descriptions.Item label={<div style={{width:'60px'}}>凭证编号</div>}>{this.state.data[0].CACode}</Descriptions.Item>
                            {/* <Descriptions.Item label="审核状态" span={2} >{this.state.data[0].CAState}</Descriptions.Item> */}
                            {this.state.data[0].CAState=='待审核'? <Descriptions.Item label="审核状态" span={2} ><div><Badge color="#2db7f5" status="processing" />待审核</div></Descriptions.Item>:''}
                        {this.state.data[0].CAState=='审批通过'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="success" />审核通过</div></Descriptions.Item>:''}
                        {this.state.data[0].CAState=='审核未通过'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="error" />审核未通过</div></Descriptions.Item>:''}
                        {this.state.data[0].CAState=='已撤回'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="default" /> 已撤回</div></Descriptions.Item>:''}
                            <Descriptions.Item label="提交时间">{this.state.data[0].CAFeedTime}</Descriptions.Item>
                            <Descriptions.Item label="提交人"  span={2}>
                            {this.state.data[0].CAComUserName}
                            </Descriptions.Item>
                            <Descriptions.Item label="还款金额（元）" span={3}>{this.state.data[0].CAAmout.toFixed(2)}</Descriptions.Item>
                            <Descriptions.Item label="凭证附件" span={3}>{(this.state.data[0].CAAttachs!=''&&this.state.data[0].CAAttachs!=null)?this.state.data[0].CAAttachs.split(';').map((item)=>{
                            return <a href={item} target="_blank"><img style={{width:'60px',height:'60px',borderRadius:'5px',marginRight:'10px'}} src={item}/></a>
                        }):'-'}</Descriptions.Item>
                            <Descriptions.Item label="备注" span={3}>
                            {this.state.data[0].CAComment}
                            <br />
                            </Descriptions.Item>
                        </Descriptions>
                        <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>审核信息</p>
                        <Descriptions size="middle" bordered>
                            <Descriptions.Item label="审核部门">{this.state.data[0].CAFeedDeptName}</Descriptions.Item>
                            <Descriptions.Item label="审核人" span={2} >{this.state.data[0].CAFeedUserName}</Descriptions.Item>
                            <Descriptions.Item label="审核结果">{this.state.data[0].CAFeedState}</Descriptions.Item>
                            <Descriptions.Item label="审核时间"  span={2}>
                            {this.state.data[0].CAFeedTime}
                            </Descriptions.Item>
                            <Descriptions.Item label={<div style={{width:'160px'}}>审核意见</div>} span={3}><div style={{wordBreak:'break-all'}}>{this.state.data[0].CAFeedAdivice}</div></Descriptions.Item>
                        </Descriptions>
                    </Card>:''}
                    {(this.state.data[0].BillAddMethod=='自动录入'&&this.state.data[0].BillType!='商家回款' )?<Card style={{marginTop:'20px'}} size="small" title="垫付账单信息"  >
                        <Descriptions size="middle" bordered>
                            <Descriptions.Item label="账单编号">{this.state.data[0].PayAccountCode}</Descriptions.Item>
                            <Descriptions.Item label="账单生成时间" span={2} >{this.state.data[0].PayCreateTime}</Descriptions.Item>
                            <Descriptions.Item label="垫付资金账户" span={3}>{this.state.data[0].AccountName}</Descriptions.Item>
                            <Descriptions.Item label="涉及主体名称">{this.state.data[0].PayComName}</Descriptions.Item>
                            <Descriptions.Item label="统一社会信用代码"  span={2}>{this.state.data[0].PayComCreditCode}</Descriptions.Item>
                            <Descriptions.Item label="收款人姓名">{this.state.data[0].CollectionUserName}</Descriptions.Item>
                            <Descriptions.Item label="联系电话"  span={2}>{this.state.data[0].CollectionUserPhone}</Descriptions.Item>
                            <Descriptions.Item label="垫付金额（元）">{EventSet.numberFormat(this.state.data[0].PayAmout,2)}</Descriptions.Item>
                            <Descriptions.Item label="收款方式"  span={2}>{this.state.data[0].CollectionUserType=='1'?'银行卡':'支付宝'}</Descriptions.Item>
                            {this.state.data[0].CollectionUserType=='1'?<Descriptions.Item label="收款银行卡号">{this.state.data[0].CollectionUserCardNo}</Descriptions.Item>:''}
                            {this.state.data[0].CollectionUserType=='1'?<Descriptions.Item label="收款银行名称"  span={2}>{this.state.data[0].CollectionUserBankName}</Descriptions.Item>:''}
                            {this.state.data[0].CollectionUserType!='1'?<Descriptions.Item label="支付宝账户"  span={2}>{this.state.data[0].CollectionUserAlipayAccount}</Descriptions.Item>:''}
                        </Descriptions>
                    </Card>:''}
                    </div>:''}
                </Drawer>
            </div>
        )
    }
}



var _Account  =null 
class Account extends React.Component{
    state={
        visible:false,
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        sorters: null,
        pagetotalCount: 0,
        accountData:[],
    }
    componentDidMount(){
        _Account =  this
        
    }
    onClose=()=>{
        this.setState({
            visible:false
        })
    }
    fench = (res) => {
        let _this = this
        this.setState({ loading: true });
        const pagination = { ...this.state.pagination };

        let setData = {
            pageSize: pagination.pageSize,
            pageNo: pagination.current,
            userCode: EventSet.getUserInfo().CU_Code,
            ComCode:EventSet.getUserInfo().xxhjcompanycode,
            AccountCode:this.state.accountData[0].AccountCode,
        };
        $.ajax({
            url: Hcurl + "/Business/GetCompanyAccountBillHistoryList",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let data = res
                console.log(data)
                 pagination.total = Number(data.Table1[0].Column1);
                _this.setState({
                    loading: false,
                    data: data.Table,
                    pagination: pagination,
                    pagetotalCount: data.Table1[0].Column1
                })
                // let data = JSON.parse(res)
                console.log(res)
                // pagination.total = Number(data.TotalCount);
                // _this.setState({
                //     loading: false,
                //     data: data.Rows,
                //     pagination: pagination,
                //     pagetotalCount: data.TotalCount
                // })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };

       //分页、排序等改变事件
    handleTableChange = (pagination, filters, sorter) => {
        let _this = this;
        this.setState({
            pagination: pagination,
            sorters: sorter
        }, () => {
            _Account.fench()
        });
    };

    toBillInfo=(code)=>{
        _Bill.setState({
            visible:true,
            
        })

        
        $.ajax({
            url: Hcurl + "/Business/GetBillSingleInfo?djCode="+code,
            type: "get", 
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let data = res
                _Bill.setState({
                    data:data
                })
     
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    render(){
        const columns = [{
            title: '单据编号',
            dataIndex: 'BillCode',
            width:250,
            render:(text,record)=>{
            return <a onClick={()=>this.toBillInfo(record.BillCode)}>{record.BillCode}</a>
            }
        }, {
            title: '单据类型',
            width:120,
            dataIndex: 'BillType',
        }, {
            title: '具体金额（元）',
            dataIndex: 'BillAmount',
            width:160,
            render:(text,record)=>{
                return (<div style={{textAlign:'right',paddingRight:'20px'}}>{EventSet.numberFormat(record.BillAmount,2)}</div>)
                }
        }, {
            title: '最近更新',
            dataIndex: 'BindTime',
            width:180,
            render:(text,record)=>{
            return (<div>{record.LastUpdatetime.substring(0,16)}</div>)
            }
        },  {
            title: '添加方式',
            dataIndex: 'BillAddMethod',
            width:180,
        },];
        return (
            <div>
               <Drawer
                    title="账户明细"
                    placement="right"
                    onClose={this.onClose}
                    visible={this.state.visible}
                    width={720}
                    >
                    <Bill/>
                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold'}}>基本信息</p>
                    {this.state.accountData.length>0?<Descriptions size="middle" bordered>
                        <Descriptions.Item label="所属主体名称" span={3}>{EventSet.getUserInfo()['XXHJCom_Name']}</Descriptions.Item>
                        <Descriptions.Item label="所属资金账户" span={3} >{this.state.accountData[0].AccountName}</Descriptions.Item>
                        <Descriptions.Item label="我的余额（元）">{EventSet.numberFormat(this.state.accountData[0].BillAmount,2)}</Descriptions.Item>
                        <Descriptions.Item label="更新时间" span={2}>{this.state.accountData[0].LastUpdatetime.substring(0,16)}</Descriptions.Item>
                    </Descriptions>:''}
                    

                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>单据明细</p>
                    <LocaleProvider locale={zh_CN}>
                                <Table
                                    rowKey={record => record.ID}
                                    pagination={this.state.pagination}
                                    loading={this.state.loading}
                                    onChange={this.handleTableChange}
                                    size="middle"
                                    bordered
                                    columns={columns}
                                    dataSource={this.state.data}
                                    scroll={{ x: 700 }}
                                />
                    </LocaleProvider>
                </Drawer>
            </div>
        )
    }
}

var _DetailMode  =null 
class DetailMode extends React.Component{
    state={
        visible:false,
        accountData:[],
    }
    componentDidMount(){
        _DetailMode =  this
    }
    onClose=()=>{
        this.setState({
            visible:false
        })
    }
    render(){
        return (
            <div>
               <Drawer
                    title="还款凭证详情"
                    placement="right"
                    onClose={this.onClose}
                    visible={this.state.visible}
                    width={720}
                    >
                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold'}}>还款信息</p>
                    {this.state.accountData.length>0? <div>
                    <Descriptions size="middle" bordered>
                        <Descriptions.Item label={<div style={{width:'60px'}}>凭证编号</div>}>{this.state.accountData[0].CACode}</Descriptions.Item>
                        {this.state.accountData[0].CAFeedState=='0'? <Descriptions.Item label="审核状态" span={2} ><div><Badge color="#2db7f5" status="processing" />待审核</div></Descriptions.Item>:''}
                        {this.state.accountData[0].CAFeedState=='1'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="success" />审核通过</div></Descriptions.Item>:''}
                        {this.state.accountData[0].CAFeedState=='2'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="error" />审核未通过</div></Descriptions.Item>:''}
                        {this.state.accountData[0].CAFeedState=='3'? <Descriptions.Item label="审核状态" span={2} ><div><Badge status="default" /> 已撤回</div></Descriptions.Item>:''}
                        <Descriptions.Item label="提交时间">{this.state.accountData[0].TjTime.substring(0,16)}</Descriptions.Item>
                        <Descriptions.Item label="提交商家" span={2}><div style={{width:'100px'}} className="lineChange" title={this.state.accountData[0].CAComName}>{this.state.accountData[0].CAComName}</div></Descriptions.Item>
                        <Descriptions.Item label="提交人" >
                        {this.state.accountData[0].CAComUserName}
                        </Descriptions.Item>
                        <Descriptions.Item label="联系电话" span={2}>
                        {this.state.accountData[0].CAComUserPhone}
                        </Descriptions.Item>
                        <Descriptions.Item label="资金账户" span={3}>{this.state.accountData[0].AccountName}</Descriptions.Item>
                        <Descriptions.Item label="还款金额（元）" span={3}>{EventSet.numberFormat(this.state.accountData[0].CAAmout,2)}</Descriptions.Item>
                        <Descriptions.Item label="凭证附件" span={3}>{(this.state.accountData[0].CAAttachs!=''&&this.state.accountData[0].CAAttachs!=null)?this.state.accountData[0].CAAttachs.split(';').map((item)=>{
                            return <a href={item} target="_blank"><img style={{width:'60px',height:'60px',borderRadius:'5px',marginRight:'10px'}} src={item}/></a>
                        }):'-'}</Descriptions.Item>
                        <Descriptions.Item label="备注" span={3}>
                        <div style={{wordBreak:'break-all'}}>{this.state.accountData[0].CAComment}</div>
                        </Descriptions.Item>
                    </Descriptions>

                    
                    {(this.state.accountData[0].CAFeedState=='1'||this.state.accountData[0].CAFeedState=='2')?
                    <div>
                    <p style={{fontSize:'14px',color:'#333',fontWeight:'bold',marginTop:'15px'}}>审核信息</p>
                    <Descriptions size="middle" bordered>
                        <Descriptions.Item label="审核部门">{this.state.accountData[0].CAFeedDeptName}</Descriptions.Item>
                        <Descriptions.Item label="审核人" span={2} >{this.state.accountData[0].CAFeedUserName}</Descriptions.Item>
                        <Descriptions.Item label="审核结果">{this.state.accountData[0].CAFeedState=='1'?'通过':'不通过'}</Descriptions.Item>
                        <Descriptions.Item label="审核时间" span={2}>{this.state.accountData[0].FeedTime.substring(0,16)}</Descriptions.Item>
                        <Descriptions.Item label={<div style={{width:'160px'}}>审核意见</div>} span={3}>
                            <div style={{wordBreak:'break-all'}}>{this.state.accountData[0].CAFeedAdivice}</div>
                        
                        </Descriptions.Item>
                    </Descriptions></div>:''}
                    
                    </div>:''}
                   
                </Drawer>
            </div>
        )
    }
}



var _App =null 
class App extends React.Component {
    state = {
        autoHeight: "",
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        sorters:'CATime desc',
        pagetotalCount: 0,
        accountData:[],
        filters:'',
        keyWordVal:'',
        CAState:'',
    }
    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }
    componentDidMount() {
        this.autoHeight();
        Event.NavShow(this, "/Content/Business/RepaymentCenter", "RepaymentCenter")//显示菜单
      
        // this.fench()
    }
    componentWillMount() {
        _App =this
    }
    changeSearch=(e)=>{
        const pagination = { ...this.state.pagination };
        pagination.current = 1;
        this.setState({
            keyWordVal: e,
            pagination
        }, () => {
            _App.fench()
        });
    }
    onChangeRadio=(e)=>{
        console.log(e)
        const pagination = { ...this.state.pagination };
        pagination.current = 1;
        this.setState({
            CAState: e.target.value,
            pagination
        }, () => {
            _App.fench()
        });
    }
   
    fench = () => {
        let _this = this
        this.setState({ loading: true });
        const pagination = { ...this.state.pagination };

        let setData = {
           
            keyWord: _App.state.keyWordVal,
            userCode: EventSet.getUserInfo().CU_Code,
            ComCode:EventSet.getUserInfo().xxhjcompanycode,
            AccountCode:_App.state.accountData[0].AccountCode,
            order:_this.state.sorters,
            CAFeedState:_this.state.filters,
            CAState:_this.state.CAState,
            pageSize: pagination.pageSize,
            pageNo: pagination.current,
        };
        $.ajax({
            url: Hcurl + "/Business/GetCompanyCollectionApplyList",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let data = res
                console.log(data)
                 pagination.total = Number(data.Table1[0].Column1);
                _this.setState({
                    loading: false,
                    data: data.Table,
                    pagination: pagination,
                    pagetotalCount: data.Table1[0].Column1
                })
                _this.getAllPage()
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };

       //分页、排序等改变事件
    handleTableChange = (pagination, filters, sorter) => {
        
        let _this = this;
        if (Object.keys(filters).length !== 0) {
            _this.setState({
                filters: filters.CAFeedState.join(';')
            })
        }
        if (Object.keys(sorter).length !== 0) {

            
            if (sorter.field == "CATime"&& sorter.order!=undefined ) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CATime desc" : "CATime asc"
                })
            }else if(sorter.field == "CATime"&& sorter.order==undefined){
                _this.setState({
                    sorters:  "" 
                })
            }
            if (sorter.field == "CAAmout"&& sorter.order!=undefined ) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CAAmout desc" : "CAAmout asc"
                })
            }else if(sorter.field == "CAAmout"&& sorter.order==undefined){
                _this.setState({
                    sorters:  "" 
                })
            }
        }
        this.setState({
            pagination: pagination,
          
        }, () => {
            _App.fench()
        });
    };
     //获取当前表格共多少页
     getAllPage() {
        let _this = this
        setTimeout(function () {
            let count = _this.state.pagination.total
            let size = _this.state.pagination.pageSize
            if (count % size !== 0) {
                let num = count - count % size
                _this.setState({
                    allPage: num / size + 1
                })
            } else {
                _this.setState({
                    allPage: count / size
                })
            }
        }, 20)
    }
    toDetailInfo=(record)=>{
        _DetailMode.setState({
            visible:true,
            record:record
        })
        $.ajax({
            url: Hcurl + "/Business/GetCompanyCollectionApplyInfo?CACode="+record.CACode,
            type: "get",
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                _DetailMode.setState({
                    accountData:res
                })
                
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    showDetail=()=>{
        _Account.setState({
            visible:true
        })
        $.ajax({
            url: Hcurl + "/Business/GetAccountInfo",
            type: "post",
            data: {
                UserCode: Event.getUserInfo().CU_Code,
                ComCode:Event.getUserInfo().xxhjcompanycode,
                AccountCode:_App.state.accountData[0].AccountCode,
            },
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                const pagination = { ..._Account.state.pagination };
                pagination.current =1
               _Account.setState({
                accountData:res,
                pagination
               })
               setTimeout(() => {
                _Account.fench(res)
               }, 100);
              
            },
            error: function (data, err) {
                // if (!JSON.parse(data.responseText).success && data.status === 403) {
                //     history.push({ "pathname": "/err" })
                // } else {
                //     message.error(err)
                // }
            }
        })

    }
    changeBill=()=>{
        _mainDawer.setState({
            visible:true
        })
    }
    sendModel=()=>{
        _SendVoucher.setState({
            visible:true,
            accountInfo:_App.state.accountData,
            states:'新增',
            fileList:[],
        })
        _SendVoucher.props.form.resetFields()
        
    }
    pubMethod(record,type){
        $.ajax({
            url: Hcurl + "/Business/OperateCompanyCollectApply",
            type: "post",
            data: {
                id:record.ID,
                UserCode: EventSet.getUserInfo()['CU_Code'],//当前操作人
                UsertTimeCode:'',// 当前操作人+ 时间戳
                ComCode: EventSet.getUserInfo()['xxhjcompanycode'],//当前选择企业code
                ComName: EventSet.getUserInfo()['XXHJCom_Name'],//当前选择企业名称
                AccountCode:'',// 当前选择资金账户code
                OperateType: type=='删除'?'2':'3',// 1 新增 2 删除 3 撤回
                CaAmount:'0',// 金额
                Attachs:'',// 附件
                Commet:'',// 备注 
                JoinMan:EventSet.getUserInfo()['userName'],// 当前操作人姓名
            },
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                console.log(res, 'res');
                if(res.indexOf('true')>-1){
                    message.success(res.split('|')[1])
                }else{
                    message.error(res.split('|')[1])
                }
                const pagination = { ..._App.state.pagination };
                pagination.current =1
                _App.setState({
                    pagination
                })
                setTimeout(() => {
                    _App.fench()
                }, 100);
                
               
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    withdraw(record){
        confirm({
            title: '撤回还款凭证？',
            content: '确定要撤回还款凭证信息吗？',
            okText:'确定',
            cancelText:'取消',
            onOk() {
                _App.pubMethod(record,'撤回')
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    }
    delect(record){
        confirm({
            title: '确定要删除当前凭证吗？',
            content: '删除后，无法恢复，请谨慎操作！',
            okText:'确定',
            cancelText:'取消',
            onOk() {
                _App.pubMethod(record,'删除')
            },
            onCancel() {
              console.log('Cancel');
            },
          });
    }
    fileName(url, array) {
        url = url || "";
        let fileName = "";
        if (url) {
            array.forEach(keys => {
                if (url.indexOf(keys) > -1) {
                    fileName = url.substring(url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } })[url.split('').map((item, index) => { if (item == '/') { return index } }).filter(item => { if (item) { return item } }).length - 1] + 1, url.indexOf(keys) - 1) + '.' + keys
                }
            })
        }
        return fileName;
    }
    reGet(record){
        let _this =this
        _SendVoucher.setState({
            visible:true,
            states:'重新提交'
        })
        $.ajax({
            url: Hcurl + "/Business/GetCompanyCollectionApplyInfo?CACode="+record.CACode,
            type: "get",
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                _SendVoucher.setState({
                    accountInfo:res
                })
                setTimeout(() => {
                    _SendVoucher.props.form.setFieldsValue({
                        repaymentMoney:res[0].CAAmout,
                        remark:res[0].CAComment,
                        CP_Attach:res[0].CAAttachs
                    })
                }, 100);
                var data =res
                if (data[0].CAAttachs !== "" && data[0].CAAttachs != null) {
                    const allImage = data[0].CAAttachs.split(";")
                    var arr = '{"filelist":[';
                    for (var i = 0; i < allImage.length; i++) {
                        

                        arr += '{"uid":"' + i + '","name":"' + _this.fileName(allImage[i],['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'txt', 'JPG', 'gif', 'GIF', 'svg', 'rm', 'rmvb', 'mpeg', 'avi', 'mp4', '3gp', 'flv', 'wmv', 'swf', 'mpg', '3gp2', 'asf', 'mpeg1', 'mpeg2', 'mpeg3', 'mpeg4', 'h264', 'flv1', 'ppt', 'pptx', 'vsd', 'pot', 'pps', 'rtf', 'wps', 'et', 'dps', 'txt', 'epub', 'rar', 'rar5', 'zip', '7z','BMP','JFIF','bmp','jfif','ico','tif','webp']) + '","status":"done","url":"' + allImage[i] + '"},';
                    }
                    arr = arr.substring(0, arr.length - 1) + "]}";
                    arr = JSON.parse(arr).filelist;
                    _SendVoucher.setState({
                        fileList: arr
                    })

                }
                
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }
    handleTableChangeInvalid=()=>{
        
    }
    render() {
        const columns = [{
            title: '凭证编号',
            dataIndex: 'CACode',
            width:250,
            render:(text,record)=>{
            return <a onClick={()=>this.toDetailInfo(record)}>{record.CACode}</a>
            }
        }, {
            title: '提交人',
            dataIndex: 'CAComUserName', 
            width:160,
            ellipsis:true,
        }, {
            title: '提交时间',
            dataIndex: 'CATime',
            width:220,
            render:(text,record)=>{

                return<div >{record.CATime.substring(0,16)}</div>
            
           
        },
            sorter:true,
        }, {
            title: '还款金额（元）',
            dataIndex: 'CAAmout',
            width:160,
            sorter:true,
            render:(text,record)=>{

                    return<div style={{textAlign:'right'}}>{record.CAAmout.toFixed(2)}</div>
                
               
            }
        }, {
            title: '备注',
            dataIndex: 'CAComment',
            width:280,
           render:(text,record)=>{
           return (<div style={{wordBreak:'break-all'}}>{record.CAComment!=''?record.CAComment:'-'}</div>)
           }
            
        },  {
            title: '审核状态',
            dataIndex: 'CAFeedState',
            width:180,
            render:(text,record)=>{
                if(record.CAFeedState=='0'){
                    return <div><Badge color="#2db7f5" status="processing" />待审核</div>
                }else if(record.CAFeedState=='1'){
                    return <div><Badge status="success" />审核通过</div>
                }else if(record.CAFeedState=='2'){
                    return <div><Badge status="error" />审核未通过</div>
                }else if(record.CAFeedState=='3'){
                    return <div><Badge status="default" /> 已撤回</div>
                }
            },
            filters: [
                { text: '待审核', value: '0' },
                { text: '审核通过', value: '1' },
                { text: '审核未通过', value: '2' },
                { text: '已撤回', value: '3' },
            ],
        }, {
                title: '操作',
                width:150,
            render: (text, record) => {
                if(record.CAFeedState=='0'){
                    return (
                        <span>
                        <a style={{marginLeft:'10px'}} onClick={()=>this.withdraw(record)}>撤回</a> 
                    </span> 
                    )
                }else if(record.CAFeedState=='1'){
                    return (
                        <span>
                        <a style={{marginLeft:'10px'}}>-</a> 
                    </span> 
                    )
                }else{
                    return (
                        <span>
                        <a style={{marginLeft:'10px'}} onClick={()=>this.reGet(record)}>重新提交</a>
                        <a style={{marginLeft:'10px'}}  onClick={()=>this.delect(record)}>删除</a>
                    </span> 
                    )
                }
                
            },
        }];
        return (
           <div id='CompanyRegistration'>
                <Crumbs title={"还款管理"} />
                <DetailMode/>
                <Account/>
                <MainDawer/>
                <SendVoucherWrapper/>
                {(this.state.accountData.length>0&&this.state.accountData[0].HasOtherAccountBillList>0)?<div style={{padding:'15px 15px 5px 15px'}}><Alert message="您还在其他资金账户存在欠款情况，可以切换至相应资金账户提交还款凭证" type="warning" showIcon /></div>:''}
                
                <div style={{margin:'15px',background:'#fff'}}>
                    <div style={{borderBottom:'1px solid #f2f2f2',padding:'10px 15px',height:'40px'}}>
                    {this.state.accountData.length>0? <div style={{float:'left'}}>{localStorage.getItem('allount')}（我的余额：{localStorage.getItem('allountMoney')<0?<span style={{color:"#FA541C",fontWeight:'bold'}}>{EventSet.numberFormat(localStorage.getItem('allountMoney'),2)}</span>:<span style={{color:"#1890ff",fontWeight:'bold'}}>{localStorage.getItem('allountMoney')}</span>} 元）</div>:<div style={{float:'left'}}>暂无资金账户</div>}
                        
                    {/* {this.state.accountData.length>0?  <a style={{float:'right'}} onClick={this.changeBill}>切换资金账户</a>:<a style={{float:'right',color:'#f2f2f2'}}>切换资金账户</a>} */}
                    {this.state.accountData.length>0?  <a onClick={this.showDetail} style={{float:'right',marginRight:'20px'}}>账户明细</a>:<a  style={{float:'right',marginRight:'20px',color:'#f2f2f2'}}>账户明细</a>}
                       
                    </div>
                    {this.state.accountData.length>0? <div style={{padding:'10px 15px'}}>
                        <p style={{margin:0}}>还款说明：</p>
                        <p style={{margin:0}}>{this.state.accountData[0].Comment }</p>
                    </div>:''}
                   
                </div>
                <div style={{ minHeight: this.state.autoHeight }} className='CompanyRegistration'>
                <div className={"BusinessTab"} style={{padding:'24px'}}>
                    <div style={{height:'40px',}}>
                        <div style={{float:'left'}}>
                        <Radio.Group disabled= {this.state.accountData.length>0?false:true } onChange={this.onChangeRadio} defaultValue='' >
                            <Radio.Button value="" style={{width:'80px',textAlign:'center'}}>全部</Radio.Button>
                            <Radio.Button value="0"  style={{width:'80px',textAlign:'center'}}>待处理</Radio.Button>
                            <Radio.Button value="1" style={{width:'80px',textAlign:'center'}}>已处理</Radio.Button>
                        </Radio.Group>
                        </div>
                        <Button disabled= {this.state.accountData.length>0?false:true } onClick={this.sendModel}  style={{float:'right'}} type="primary">提交还款凭证</Button>
                        <Search disabled= {this.state.accountData.length>0?false:true } style={{float:'right',width:'300px',marginRight:'12px'}} placeholder="关键字搜索" onSearch={value => this.changeSearch(value)} enterButton />
                        

                    </div>
                    <div style={{ position: "relative", margin: "20px 0" }}>
                            <LocaleProvider locale={zh_CN}>
                                <Table
                                    rowKey={record => record.ID}
                                    pagination={this.state.pagination}
                                    loading={this.state.loading}
                                    onChange={this.state.accountData.length>0?this.handleTableChange: this.handleTableChangeInvalid}
                                    size="middle"
                                    bordered
                                    columns={columns}
                                    dataSource={this.state.data}
                                    scroll={{ x: 1100 }}
                                />
                            </LocaleProvider>
                        <div style={{ position: "absolute", bottom: "20px", left: "0px" }}>
                            共 {this.state.pagetotalCount}条记录，第{this.state.pagination.current}/{this.state.allPage}页
                        </div>
                    </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}
const RegWrap = Form.create()(App);
export default connect()(RegWrap)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyRepayment/RepaymentCenter/RepaymentCenter.js